// Номера, которые ученик добил ПРАВИЛЬНО в «Работе над ошибками» за текущий сеанс.
// Хранится только в памяти (модульная переменная) → сбрасывается при полной
// перезагрузке страницы. Это осознанно: результат тренировки НЕ сохраняется,
// каждый заход после reload — снова из всех текущих ошибок. Но в пределах сеанса
// решённые номера исчезают из списка (и из счётчика на странице Прогресс).
const cleared = new Set();

export const isMistakeCleared = (id) => cleared.has(id);
export const clearMistakes = (ids) => (ids || []).forEach(id => cleared.add(id));
